// userSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  userData: null,
  profileData: null,
  language: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.userData = action.payload;
    },
    profileData: (state, action) => {
      state.isAuthenticated = true;
      state.profileData = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userData = null;
    },
    updateUser: (state, action) => {
      state.userData = action.payload;
    },
    updateLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { login, logout, updateUser, updateLanguage, profileData } =
  userSlice.actions;

export default userSlice.reducer;
